<template>
  <div id="app">
    <router-view></router-view>
    <notifications group="foo"/>
  </div>
</template>

<script>

export default {
  name: 'app',
  data() {
    return {
    };
  },
  components: {
    // StoreInfo,
  },
  methods: {
  },
  mounted() {
  },
  computed: {
  },
};
</script>

<style lang="sass">
@import url('https://fonts.googleapis.com/css?family=Montserrat:300,400,500,600,700,800,900&display=swap&subset=cyrillic,cyrillic-ext,latin-ext')
body
  overflow-x: hidden
  background: #eeeeee
  margin: 0
  font-family: 'Montserrat', sans-serif
  &.modal-open
    overflow-y: hidden
#app
  text-align: center
  font-family: 'Montserrat', sans-serif
  .container
    max-width: rem(960)
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button
  -webkit-appearance: none
  margin: 0
input[type='number']
  -moz-appearance: textfield

.data
  position: absolute
  right: -20%
  top: 0
  // display: none
.code
  position: absolute
  opacity: 0
  pointer-events: none
  transition: .5s
  transform: translateY(-100%)
  width: 100%
  padding: 20px
  background: lime
  left: 0
  right: 0
  margin: auto
  display: block
  input
    width: 80%
    margin: auto
    display: block
  &.active
    transform: translateY(50%)
    opacity: 1
    pointer-events: auto
</style>
